// ETAPA escolha especificador / cliente
import React, { useEffect, useContext, useState } from "react";
import { DefaultTheme, ThemeContext } from "styled-components";

import { Hero, Button } from "../../../../components";

import { Container, Section, Buttons } from "./styles";
import { NavigateButtonsContext, DataUserContext } from "../../../Criare";
import { sendClient, sendEspecificador, getStoresByLink } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";
import { useLocation } from "react-router-dom";

const Question16: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { setHomeIgnored, token } = useContext(DataUserContext);
  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);
  const [answer, setAnswer] = useState<boolean>();

  const location = useLocation();

  async function loadScript() {
    var preLojas = await getStoresByLink(location.pathname.substring(1), token);
    var existing = document.getElementById("tagmanager"),
        existingPixel = document.getElementById("pixelface");

    if( location.pathname.substring(1) !== ''){
      document.getElementById('link-canonical').remove();

      let nodeCanonical = document.createElement('link');
          nodeCanonical.setAttribute("rel", "canonical");
          nodeCanonical.setAttribute("href", "https://seuprojeto.criare.com/jornada/" + location.pathname.substring(1));
          document.getElementsByTagName('head')[0].appendChild(nodeCanonical);
    }
    
    if (!existing) {
      var tagmanager = preLojas.cidades !== undefined && preLojas.cidades[0] !== undefined && preLojas.cidades[0].tagmanager !== null ? preLojas.cidades[0].tagmanager : 'GTM-NSP5XPD';
      let node = document.createElement('script');
        node.textContent = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + tagmanager + "');";
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        node.setAttribute("id", "tagmanager");
        document.getElementsByTagName('head')[0].appendChild(node);

        let nodeBody = document.createElement('noscript');
        nodeBody.textContent = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + tagmanager + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
        document.getElementsByTagName('body')[0].prepend(nodeBody);
    }
    
    if (!existingPixel) {
        var pixelface = preLojas.cidades !== undefined && preLojas.cidades[0] !== undefined && preLojas.cidades[0].pixelface !== null ? preLojas.cidades[0].pixelface : '894961004362617';
        let node = document.createElement('script');node.textContent = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '" + pixelface + "');fbq('track', 'PageView');fbq('track', 'CompleteRegistration');";
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        node.setAttribute("id", "pixelface");
        document.getElementsByTagName('head')[0].appendChild(node);

        let nodeBody = document.createElement('noscript');
        nodeBody.textContent = '<img height="1" width="1" style="display:none"src="https://www.facebook.com/tr?id=' + pixelface + '&ev=PageView&noscript=1"/>';
        document.getElementsByTagName('body')[0].prepend(nodeBody);
    }
  }

  useEffect(() => {
    if (_theme.steps) {
      loadScript();
      setTheme(_theme);
      console.log(_theme);
    }
  }, [_theme]);

  useEffect(() => {
    if (answer === true) {
      sendEspecificador("especificar", token);
      next(17);
    } else if (answer === false) {
      setHomeIgnored(true);
      sendClient("cliente", token);
      
      next(4); //Tela nome
      // next(2); Tela saber estilo
    }
  }, [answer, next, token, setHomeIgnored]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 16);
    setHomeIgnored(false);
  }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_especificador.propriedades.imagens.etapa_especificador_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_especificador.propriedades.banner.subtituloBanner"
            )}
            subscript={can(
              theme,
              "theme.steps.etapa_especificador.propriedades.banner.tituloBanner"
            )}
            isHome
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador.propriedades.conteudo.titulo"
              )}
            </p>

            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador.propriedades.conteudo.subtitulo"
              )}
            </p>

            <Buttons>
              <Button
                criare
                icon={
                  <img 
                    src={can(
                      theme,
                      "theme.steps.etapa_especificador.propriedades.imagens.etapa_especificador_iconeNao.url"
                    )}
                    alt="Cliente"
                  />
                }
                title={can(
                  theme,
                  "theme.steps.etapa_especificador.propriedades.conteudo.texto_nao"
                )}
                onClick={() => {
                  setAnswer(false);
                }}
              />
              <Button
                criare
                icon={
                  <img
                    src={can(
                      theme,
                      "theme.steps.etapa_especificador.propriedades.imagens.etapa_especificador_iconeSim.url"
                    )}
                    alt="Especificador"
                  />
                }
                title={can(
                  theme,
                  "theme.steps.etapa_especificador.propriedades.conteudo.texto_sim"
                )}
                onClick={() => {
                  setAnswer(true);
                }}
              />
            </Buttons>
          </Section>
        </Container>
      )}
    </>
  );
};

export default Question16;
